import $ from "jquery";
// Tracks changes to any of the customization fields
window.changed = false;

// (iframe initialization now handled by Stimulus controller)

window.store_viewer_settings = function () {

    const viewerInstance = window.viewer();
    if (viewerInstance && !viewerInstance.original_settings) {

        // Store viewer settings that will be restored on close
        viewerInstance.original_settings = {};
        viewerInstance.original_settings.zoom = viewerInstance.settings.zoom;
        viewerInstance.original_settings.fullscreen = viewerInstance.settings.fullscreen;
        viewerInstance.original_settings.manual_spin = viewerInstance.settings.manual_spin;
        viewerInstance.original_settings.auto_spin = viewerInstance.settings.auto_spin;
        viewerInstance.original_settings.auto_spin_count = viewerInstance.settings.auto_spin_count;
        viewerInstance.original_settings.auto_spin_speed = viewerInstance.settings.auto_spin_speed;

        return viewerInstance.original_settings.auto_spin_speed;
    } else if (!viewerInstance) {
        console.log('[Variants] No viewer available for storing settings');
    } else {
        console.log('[Variants] Viewer settings already stored');
    }
};


window.reset_viewer_settings = function () {
    console.log('[Variants] Resetting viewer settings...');
    const viewerInstance = window.viewer();
    if (viewerInstance && viewerInstance.original_settings) {
        console.log('[Variants] Viewer available, restoring original settings:', viewerInstance.original_settings);
        // Restore original viewer settings
        viewerInstance.zoom(viewerInstance.original_settings.zoom);
        viewerInstance.fullscreen(viewerInstance.original_settings.fullscreen);
        viewerInstance.manual_spin(viewerInstance.original_settings.manual_spin);
        viewerInstance.auto_spin(viewerInstance.original_settings.auto_spin);
        viewerInstance.auto_spin_count(viewerInstance.original_settings.auto_spin_count);
        viewerInstance.auto_spin_speed(viewerInstance.original_settings.auto_spin_speed);
        console.log('[Variants] Settings restored');
    } else if (!viewerInstance) {
        console.log('[Variants] No viewer available for resetting settings');
    } else {
        console.log('[Variants] No original settings to restore');
    }
};


window.parseAndValidateInt = function (value, min, max) {
    value = parseInt(value);
    if (isNaN(value) || (value.length === 0)) {
        value = 1;
    }
    if (value < min) {
        value = min;
    }
    if (value > max) {
        value = max;
    }
    return value;
};

window.parseAndValidateColor = function (value) {
    // Allow 3 or 5 digits hex only
    if ("transparent" === value) {
        return value;
    } else if (/^#?[a-fA-F0-9]{3}([a-fA-F0-9]{3})?$/.test(value)) {
        return value.replace("#", "");
    } else {
        return "FFFFFF";
    }
};

window.parseAndValidateTargetAspectRatio = function (value) {
    // Allow original or 16:9
    if ("original" === value) {
        return value;
    } else if ("16:9" === value) {
        return value;
    } else {
        return "16:9";
    }
};

// Lightweight helper to show a toast in the default app container (#toasts),
// using (almost) the same markup conventions as shared/_toast.html.erb.
function showDownloadToast(message) {
    const $container = $('#toasts');
    if ($container.length === 0) {
        // Fallback: if the standard container is not present, do nothing.
        return;
    }

    // Match shared/_toast.html.erb as closely as possible:
    // - same classes and ARIA attributes
    // - same inline styles
    // - same green color as a "success" toast (#28a745)
    const $toast = $(`
      <div class="toast"
           data-controller="toast"
           role="alert"
           aria-live="assertive"
           aria-atomic="true"
           data-bs-autohide="true"
           data-bs-delay="8000"
           style="min-width: 20em; margin-bottom: 0.5em; border: none !important; background-color: #fff; box-shadow: none !important;">
        <div class="toast-body" style="font-size: 0.875rem;">
          <span style="color: #28a745; font-weight: 500;"></span>
        </div>
      </div>
    `);

    // Set the message as text content to mirror the sanitized span in the ERB partial.
    $toast.find('span').text(message);

    $container.append($toast);
}

// Trigger a file download without navigating away from the current page,
// by loading the URL in a hidden iframe.
function triggerFileDownload(url) {
    let iframe = document.getElementById('download-frame');
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'download-frame';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
    }
    iframe.src = url;
}

// Shared helper to disable both download links to prevent double-clicks.
function setDownloadLinksDisabled(disabled) {
    const $links = $('#download_single, #download_all');
    if (disabled) {
        $links
            .addClass('disabled')
            .attr('aria-disabled', 'true')
            .css({
                pointerEvents: 'none',
                opacity: 0.5,
                cursor: 'not-allowed'
            });
    } else {
        $links
            .removeClass('disabled')
            .removeAttr('aria-disabled')
            .css({
                pointerEvents: '',
                opacity: '',
                cursor: ''
            });
    }
}

// Handle "Download current image" and "Download all images" actions on the variant page.
function bindDownloadCurrentImage() {
    // Ensure we don't register the handler multiple times across Turbo visits.
    $(document).off('click.downloadSingle', '#download_single');
    $(document).off('click.downloadAll', '#download_all');

    $(document).on('click.downloadSingle', '#download_single', function (event) {
        event.preventDefault();

        // Disable both links while the browser initiates the download.
        setDownloadLinksDisabled(true);

        showDownloadToast('Downloading current image...');

        const $link = $(this);
        const baseUrl = $link.data('action');
        if (!baseUrl) {
            console.warn('[Variants] Missing data-action URL on #download_single link');
            setDownloadLinksDisabled(false);
            return;
        }

        // Try to read the current frame from the viewer, falling back safely.
        let ordial = 1;
        try {
            const viewerInstance = window.viewer && window.viewer();
            if (viewerInstance) {
                const current = typeof viewerInstance.ordial === 'number' && viewerInstance.ordial > 0
                    ? viewerInstance.ordial
                    : viewerInstance.index;

                if (typeof current === 'number' && current > 0) {
                    ordial = current;
                }
            }
        } catch (e) {
            console.warn('[Variants] Unable to read current frame from viewer for download_single', e);
        }

        const url = `${baseUrl}?ordial=${encodeURIComponent(ordial)}`;
        triggerFileDownload(url);

        // Re-enable links shortly after navigation so the user can trigger
        // another download later, while still preventing rapid double-clicks.
        setTimeout(function () {
            setDownloadLinksDisabled(false);
        }, 2000);
    });

    // Ensure "Download all images" triggers a real browser navigation (bypassing Turbo),
    // and disable both links once clicked.
    $(document).on('click.downloadAll', '#download_all', function (event) {
        event.preventDefault();

        setDownloadLinksDisabled(true);

        showDownloadToast('Downloading all images...');

        const href = $(this).attr('href');
        if (!href) {
            console.warn('[Variants] Missing href on #download_all link');
            setDownloadLinksDisabled(false);
            return;
        }

        // Trigger download in a hidden iframe to keep the current page (and toasts) visible.
        triggerFileDownload(href);

        setTimeout(function () {
            setDownloadLinksDisabled(false);
        }, 2000);
    });
}

document.addEventListener('turbo:load', bindDownloadCurrentImage);
document.addEventListener('DOMContentLoaded', bindDownloadCurrentImage);
